import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class RolesAdd extends Component{
	render(){
		const {roles} =this.props;
		let rc = _.find(roles.permissions, (o) => {return o==='Create'});
		return (
			rc ?
				<p>
					<NavLink to={`/perfiles/crear`} className="button is-small is-inm-purple">{'Agregar perfil'}</NavLink>
				</p>
				:''
		)
	}
}

export default SecureLayout(RolesAdd);


// WEBPACK FOOTER //
// ./src/elements/roles/widget/roles_add.jsx